import React, { useEffect, useRef } from 'react'
import { Button, CenterPopup } from 'antd-mobile-v5'
import { FormattedMessage, useIntl } from 'react-intl'
import QRCodeGenerator from '../common/QRCodeGenerator'

import styles from './QrCodePay.module.css'

/**
 * WPOS 扫码支付弹窗（单二维码）。
 * <p>
 * 前端先选渠道（WECHAT/ALIPAY），后端返回对应渠道的单码 URL。
 */
const QrCodePay = ({ visible, setVisible, url, price, currency, titleId = 'fuiou-qr-title' }) => {
  const { formatMessage } = useIntl()
  const cancelRef = useRef(null)
  // 金额展示（CHNA-2618 后端补出 price/currency）：只展示不计算，price 已是两位小数字符串；
  // 0 元（优惠券全额抵扣）为合法状态照常展示。币种缺省按富友通道恒 CNY 处理
  const hasPrice = price != null && price !== ''
  const isCny = !currency || currency === 'CNY'
  const amountText = hasPrice ? (isCny ? `¥${price}` : `${price} ${currency}`) : null

  // 弹窗打开时把焦点移入弹窗（取消按钮），支持键盘用户
  useEffect(() => {
    if (visible && cancelRef.current) {
      cancelRef.current.focus()
    }
  }, [visible])

  return (
    <CenterPopup visible={visible}>
      <div className={styles.title}>{formatMessage({ id: titleId })}</div>
      {amountText && (
        <div className={styles.amount}>
          <FormattedMessage id="fuiou-qr-amount" values={{ amount: amountText }} />
        </div>
      )}
      <QRCodeGenerator width={200} height={200} url={url} />
      <div className={styles.hint}>{formatMessage({ id: 'fuiou-qr-hint' })}</div>
      <div className={styles['cancel-btn']}>
        <Button
          ref={cancelRef}
          block
          onClick={() => {
            setVisible(false)
          }}
        >
          取消支付
        </Button>
      </div>
    </CenterPopup>
  )
}

export default QrCodePay
